function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SelectNFTTemplate = require('./select-nft-overlay.template');
var NFTCard = require('./../saito-nft-card');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoUser = require('./../../saito-user/saito-user');
var CreateNFT = require('./create-overlay');
var NFTOverlay = require('./nft-overlay');
var SelectNFT = /*#__PURE__*/function () {
  function SelectNFT(app, mod) {
    var _app$browser,
      _this = this;
    var attach_events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, SelectNFT);
    this.app = app;
    this.mod = mod;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
    }
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.create_nft_overlay = new CreateNFT(this.app, this.mod);
    this.nft_overlay = new NFTOverlay(this.app, this.mod);
    this.card_list = [];
    this.callback = null;
    if (attach_events) {
      this.app.connection.on('saito-nft-list-render-request', function () {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        _this.title = title;
        _this.callback = callback;
        _this.render(filter);
      });
      this.app.connection.on('saito-nft-list-close-request', function () {
        _this.overlay.close();
      });

      // Prefer wallet-updated (not on-nft-sent/received): options.wallet.nfts
      // is only fresh after updateNFTList. Await sync before re-render so we
      // don't race the Wallet module's own async listener.
      app.connection.on('wallet-updated', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$app$wallet;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(typeof ((_this$app$wallet = _this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.updateNFTList) === 'function')) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this.app.wallet.updateNFTList();
            case 1:
              if (!_this.overlay.visible) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return _this.render();
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.n = 4;
              return _this.updateCardList();
            case 4:
              return _context.a(2);
          }
        }, _callee);
      })));
    }
  }
  return _createClass(SelectNFT, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var filter,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              filter = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
              this.overlay.show(SelectNFTTemplate(this));
              _context2.n = 1;
              return this.renderNFTList(filter);
            case 1:
              setTimeout(function () {
                _this2.attachEvents();
              }, 25);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "updateCardList",
    value: function () {
      var _updateCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var nft_list, _iterator, _step, rec, already_rendered, i, j, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              nft_list = this.app.options.wallet.nfts || []; // We want to avoid recreating the cards every time we look launch the overlay
              // but we need to check if we have added *or* removed an nft and adjust as needed
              this.card_list.forEach(function (x) {
                return x.delete_me = true;
              });
              _iterator = _createForOfIteratorHelper(nft_list);
              _context3.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context3.n = 7;
                break;
              }
              rec = _step.value;
              // To capture split nfts... i think
              already_rendered = false;
              i = 0;
            case 3:
              if (!(i < this.card_list.length)) {
                _context3.n = 5;
                break;
              }
              if (!(rec.id == this.card_list[i].nft.id)) {
                _context3.n = 4;
                break;
              }
              this.card_list[i].callback = this.callback;
              delete this.card_list[i].delete_me;
              already_rendered = true;
              return _context3.a(3, 5);
            case 4:
              i++;
              _context3.n = 3;
              break;
            case 5:
              if (!already_rendered) {
                this.card_list.push(new NFTCard(this.app, this.mod, '.send-nft-list', null, rec, this.callback));
              }
            case 6:
              _context3.n = 2;
              break;
            case 7:
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t = _context3.v;
              _iterator.e(_t);
            case 9:
              _context3.p = 9;
              _iterator.f();
              return _context3.f(9);
            case 10:
              for (j = this.card_list.length - 1; j >= 0; j--) {
                if (this.card_list[j].delete_me) {
                  this.card_list.splice(j, 1);
                }
              }
            case 11:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 8, 9, 10]]);
      }));
      function updateCardList() {
        return _updateCardList.apply(this, arguments);
      }
      return updateCardList;
    }()
  }, {
    key: "renderNFTList",
    value: function () {
      var _renderNFTList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(filter) {
        var _this$card_list,
          _this3 = this;
        var container, instructionsEl, html, _iterator2, _step2, card, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              container = document.querySelector('#nft-list');
              instructionsEl = document.querySelector('.saito-nft-list #nft-list-instructions');
              if (container) {
                _context4.n = 1;
                break;
              }
              console.warn('Missing NFT-list container!');
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return this.updateCardList();
            case 2:
              if ((_this$card_list = this.card_list) !== null && _this$card_list !== void 0 && _this$card_list.length) {
                _context4.n = 3;
                break;
              }
              container.innerHTML = '<div class="send-nft-list"></div>';
              if (instructionsEl) {
                instructionsEl.innerHTML = "\n          <div class=\"instructions\">\n            You do not yet have any NFTs in your wallet.\n          </div>\n        ";
              }
              return _context4.a(2);
            case 3:
              if (instructionsEl) {
                instructionsEl.innerHTML = '';
              }

              // if nft-list contains nft
              html = '<div class="send-nft-list"></div>';
              container.innerHTML = html;
              _iterator2 = _createForOfIteratorHelper(this.card_list);
              _context4.p = 4;
              _iterator2.s();
            case 5:
              if ((_step2 = _iterator2.n()).done) {
                _context4.n = 7;
                break;
              }
              card = _step2.value;
              if (!card.callback) {
                card.callback = function (nft) {
                  _this3.nft_overlay.render(nft);
                };
              }
              if (!(!filter || filter == card.nft.returnType())) {
                _context4.n = 6;
                break;
              }
              _context4.n = 6;
              return card.render();
            case 6:
              _context4.n = 5;
              break;
            case 7:
              _context4.n = 9;
              break;
            case 8:
              _context4.p = 8;
              _t2 = _context4.v;
              _iterator2.e(_t2);
            case 9:
              _context4.p = 9;
              _iterator2.f();
              return _context4.f(9);
            case 10:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 8, 9, 10]]);
      }));
      function renderNFTList(_x) {
        return _renderNFTList.apply(this, arguments);
      }
      return renderNFTList;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var newNFTButton = document.getElementById('create-nft');
      if (newNFTButton) {
        newNFTButton.onclick = function (e) {
          _this4.overlay.close();
          _this4.create_nft_overlay.render();
        };
      }
    }
  }]);
}();
module.exports = SelectNFT;